import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sumByProperty'
})
export class SumByPropertyPipe implements PipeTransform {
  transform(items: any[], property: string): number {
    if (!items || !items.length) {
      return 0;
    }

    // Handle nested properties like 'oldCustomer.months[0]'
    return items.reduce((sum, item) => {
      let value = item;
      const props = property.split('.');
      
      // Navigate through nested properties
      for (const prop of props) {
        if (!value) return sum;
        
        // Handle array access like months[0]
        if (prop.includes('[') && prop.includes(']')) {
          const propName = prop.substring(0, prop.indexOf('['));
          const index = parseInt(prop.substring(prop.indexOf('[') + 1, prop.indexOf(']')));
          
          if (!value[propName] || !value[propName][index]) {
            return sum;
          }
          
          value = value[propName][index];
        } else {
          // Regular property access
          if (!value[prop]) {
            return sum;
          }
          
          value = value[prop];
        }
      }
      
      // Convert to number if it's not already
      const numValue = Number(value) || 0;
      return sum + numValue;
    }, 0);
  }
}
